module.exports = __webpack_public_path__ + "static/img/pay_more_alipay.49ecfa6b.png";